import SMLogoComponent from './SMLogoComponent';

const SMLogo = SMLogoComponent;

export default SMLogo;
